import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useWindowSize from "../../hooks/useWindowSize";
import img1 from "../../assets/images/slider/pic1.jpg";
import img2 from "../../assets/images/slider/pic2.jpg";
import img3 from "../../assets/images/slider/pic3.jpg";
import mImg1 from "../../assets/images/slider/mobile/pic 1.png";
import mImg2 from "../../assets/images/slider/mobile/pic 2.png";
import mImg3 from "../../assets/images/slider/mobile/pic 3.png";
import mImg4 from "../../assets/images/slider/mobile/pic 4.png";
export default function FirstSlider() {
  const { width } = useWindowSize();
  const mobileSlide = [mImg1, mImg2, mImg3, mImg4];
  const laptopSlide = [img1, img2, img3];
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className="mt-2">
      <div>
        <Slider {...settings}>
          {(width > 500 ? laptopSlide : mobileSlide).map((m, i) => {
            return (
              <div key={`firstSlider${i}`}>
                <img src={m} style={{ width: "100%" }} className="rounded" />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
